import { Paragraph } from '@zillow/constellation-10';

const WizardTipContent = (): JSX.Element => {
  return (
    <div data-testid="WizardTipContent">
      <Paragraph>
        A Rent Zestimate® is Zillow&apos;s estimated monthly rental price, computed using a proprietary formula. It is a
        starting point in determining the monthly rental price for a specific property.
      </Paragraph>
    </div>
  );
};

export default WizardTipContent;
